/* ============================================================
   CRC-REVEAL — scroll-reveal storybook (vanilla, 0 deps)
   Auto-taga por seletor: nada de editar sections nativas.
   Efeitos: rise · pop · tilt-left · tilt-right · splash
   Sem IO / reduced-motion → nada é escondido (fallback nato).
   ============================================================ */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var MAP = [
    ['.collection-card', 'pop', 60, 0],
    ['.product-card', 'pop', 60, 0],
    ['.crc-collage__title', 'rise', 0, 0],
    ['.crc-polaroid', 'alt', 90, 0],
    ['.crc-collage .crc-sticker', 'splash', 120, 150],
    ['.crc-collage > .button, .crc-videoband > .button, .crc-crew-cta .button', 'rise', 0, 180],
    ['.crc-videoband__title, .crc-videoband__sub', 'rise', 80, 0],
    ['.crc-videoband__frame', 'pop', 0, 120],
    ['.crc-dude-bubble', 'splash', 0, 0],
    ['.crc-chips__hint', 'rise', 0, 0],
    ['.crc-chip', 'pop', 50, 0],
    ['.rte img[src*="Web_Profile"], .rte img[src*="crc-dude-new"]', 'alt', 80, 0],
    ['[id*="section_QGqdEc"] h2, [id*="section_QGqdEc"] .email-signup', 'rise', 90, 0],
    ['accordion-custom', 'rise', 50, 0],
    ['.crc-in-action__grid > *', 'pop', 80, 0],
    ['.crc-meet__art img', 'splash', 100, 0],
    ['.crc-values__row > div', 'rise', 90, 0]
  ];

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('fx-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  var groups = new Map();
  MAP.forEach(function (row) {
    document.querySelectorAll(row[0]).forEach(function (el, idx) {
      if (el.hasAttribute('data-fx')) return;
      var p = el.parentElement || document.body;
      var i = Math.min(groups.get(p) || 0, 6);
      groups.set(p, (groups.get(p) || 0) + 1);
      el.setAttribute('data-fx', row[1] === 'alt' ? (idx % 2 ? 'tilt-right' : 'tilt-left') : row[1]);
      el.style.setProperty('--fx-i', row[2] ? i : 0);
      el.style.setProperty('--fx-stagger', (row[2] || 0) + 'ms');
      el.style.setProperty('--fx-delay', (el.getAttribute('data-fx-delay') || row[3] || 0) + 'ms');
      io.observe(el);
    });
  });

  /* D1 — tap-wiggle nos stickers */
  document.addEventListener('pointerdown', function (e) {
    var s = e.target.closest('.crc-sticker');
    if (!s) return;
    s.classList.remove('is-wiggling');
    void s.offsetWidth;
    s.classList.add('is-wiggling');
  }, { passive: true });

  /* D2 — haptic no ATC (Android; iOS ignora) */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.sticky-add-to-cart__button, .product-form-buttons [type="submit"], product-form-component [type="submit"]')
        && navigator.vibrate) navigator.vibrate(12);
  }, { passive: true });

  /* Micro-delícia: bolhas no clique (pointer fino) */
  var lastPop = 0;
  if (window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('pointerdown', function (e) {
      if (e.target.closest('input, textarea, select, label, [contenteditable]')) return;
      var now = Date.now(); if (now - lastPop < 160) return; lastPop = now;
      for (var i = 0; i < 3; i++) {
        var b = document.createElement('span');
        b.className = 'crc-pop-bubble';
        var sz = 6 + Math.random() * 9;
        b.style.cssText = 'left:' + (e.clientX + (Math.random() * 26 - 13)) + 'px;top:' +
          (e.clientY - Math.random() * 8) + 'px;width:' + sz + 'px;height:' + sz + 'px;animation-delay:' + (i * 70) + 'ms';
        document.body.appendChild(b);
        b.addEventListener('animationend', function () { this.remove(); });
      }
    }, { passive: true });
  }

  /* MERGULHO: burst + véu cyan ao navegar interno (dispara e deixa ir) */
  var lastDive = 0;
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '/' || href.indexOf('//') === 0) return;
    if (href.indexOf('/cart') === 0 || a.closest('cart-drawer')) return;
    var now = Date.now(); if (now - lastDive < 600) return;
    lastDive = now; lastPop = now + 400;

    var vw = innerWidth, vh2 = innerHeight;
    var ox = e.clientX || vw / 2;
    var oy = Math.max(e.clientY || vh2 * .7, vh2 * .5);
    var n = 10 + Math.floor(Math.random() * 5);
    for (var i = 0; i < n; i++) {
      var b = document.createElement('span');
      b.className = 'crc-pop-bubble crc-pop-bubble--dive';
      var sz = 6 + Math.random() * 16;
      var x = Math.min(Math.max(ox + (Math.random() - .5) * vw * .6, 8), vw - 30);
      var y = Math.min(oy + Math.random() * (vh2 - oy), vh2 - 12);
      b.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:' + sz + 'px;height:' + sz +
        'px;--rise:' + Math.round(120 + Math.random() * 260) + 'px;animation-delay:' +
        Math.round(Math.random() * 110) + 'ms';
      document.body.appendChild(b);
      b.addEventListener('animationend', function () { this.remove(); });
    }
    var veil = document.createElement('div');
    veil.className = 'crc-dive-veil';
    document.body.appendChild(veil);
    veil.addEventListener('animationend', function () { this.remove(); });
  }, { passive: true });
})();
